
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { checkAndInitGA } from './utils/analytics'

// Check and initialize Google Analytics based on cookie consent
// This needs to happen before the app renders to ensure GA is ready
// for the initial page view tracking
if (typeof window !== 'undefined') {
  checkAndInitGA();
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
